export class NoPermission {

}